<template>
    <validation-observer ref="timeForm">
        <div>
            <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
                <label  :class="{' col-md-3 col-xs-4' : isInquiry , 'attribute-label' : !isInquiry}" :for="id">
                    {{ question.question_text }}

                </label>
                <validation-provider :rules="question.mandatory ? 'required' : ''" v-slot="{errors}">
                    <div :class="{' col-md-9 col-xs-8' : isInquiry}" >
                        <div class="time-attribute input-group" >
                            <input ref="time" :id="id" :name="name" class="form-control input-group-new-design"
                                   placeholder="Time" v-model="question.value" @blur="changeTime">
                            <input type="hidden" :value="id" name="questions[]" >
                            <span class="input-group-addon input-group-addon-new-design"><span
                                class="glyphicon glyphicon-time"></span></span>
                        </div>
                        <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
                        <span class="text text-danger error-label" v-if="errors && errors.length">{{ errors[0] }}</span>
                    </div>

                </validation-provider>
            </div>
        </div>
    </validation-observer>
</template>

<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import moment from "moment/moment";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormTime",
    props: {
        value: {},
        timeFormat: {
            required: true,
            type: String
        },
        isPopUp:false,
        viewPage:false,
        isInquiry:false,
        inquiryId:0
    }, components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            question: this.value
        }
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        }
    },
    methods: {
        changeTime(){
            if(this.viewPage && this.isInquiry){
                updateFormQuestionOnViewInquiry(this.question.value, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
            }
        },
        addEventListeners() {
            EventBus.$on('onFormsAndCheckListsValidation', async (verify) => {
                if(this.$refs.timeForm) {
                    let validated = await this.$refs.timeForm.validate();
                    verify(validated)
                }
            })

        },
        removeEventListeners(){
            EventBus.$off('onFormsAndCheckListsValidation');
        },
        initiateTimePicker() {
            this.$nextTick(() => {
                // Initialize the datetimepicker with the initial value if it exists
                let initialValue = this.question.answer_text_names
                    ? moment(this.question.answer_text_names, this.timeFormat)
                    : null;

                if (initialValue) {
                    this.question.value = initialValue.format(this.timeFormat);
                }
                if(this.$refs['time']){
                    this.input = $(this.$refs['time']).datetimepicker({
                        format: this.timeFormat,
                    })
                }
                this.addTimePickerEventListener();
            })
        },
        addTimePickerEventListener() {
            this.input.on('dp.change', (event) => {
                this.question.value = event.target.value
            })
        },
    },
    mounted() {
        this.addEventListeners()
        this.$nextTick(() => {
            this.initiateTimePicker();
        })
    },
    watch: {
        question: {
            handler(question) {
                this.$emit('input', question)
            },
            deep: true
        }
    },
    destroyed() {
        this.removeEventListeners();
    }
}
</script>

<style scoped>
.p-0-1{
    padding:0px 1px;
}

</style>